import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { DEFAULT_GAME_ID, LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'

export const getAllCurrencyService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-all-currency', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}
export const getGameSettingService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-game-settings', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table,
    params
  })
}

export const getGameDetailsService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-game-settings', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}

export const verifyRoundHashService = (data) => {
  let endPoint = ''
  let payLoadData = {}
  if (data.gameId === DEFAULT_GAME_ID.CRASH ||
    data.gameId === DEFAULT_GAME_ID.CHOPPER_CRASH ||
    data.gameId === DEFAULT_GAME_ID.SOCCER_CRASH ||
    data.gameId === DEFAULT_GAME_ID.MULTI_CRASH) {
    endPoint = 'fast-games/crash-game/check-fairness'
    payLoadData = {
      roundHash: data.hashCode,
      currencyCode: data.currencyCode
    }
  }
  switch (data.gameId) {
    case DEFAULT_GAME_ID.PLINKO:
    case DEFAULT_GAME_ID.PYRAMID_PLINKO:
      endPoint = 'fast-games/plinko-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed,
        numberOfRows: data?.numberOfRows,
        riskLevel: data?.riskLevel,
        currencyCode: data.currencyCode
      }
      break

    case DEFAULT_GAME_ID.KENO:
      endPoint = 'fast-games/keno-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed,
        riskLevel: data?.riskLevel
      }
      break

    case DEFAULT_GAME_ID.DICE:
      endPoint = 'fast-games/dice-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    case DEFAULT_GAME_ID.VIDEO_POKER:
      endPoint = 'fast-games/video-poker-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    case DEFAULT_GAME_ID.HILO:
      endPoint = 'fast-games/hilo-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    case DEFAULT_GAME_ID.BLACKJACK:
      endPoint = 'fast-games/blackjack-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    case DEFAULT_GAME_ID.LIMBO:
      endPoint = 'fast-games/limbo-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    case DEFAULT_GAME_ID.ROULETTE:
      endPoint = 'fast-games/roulette-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    case DEFAULT_GAME_ID.MINE:
      endPoint = 'fast-games/mine-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed,
        mineCount: data?.numberOfMines
      }
      break

    case DEFAULT_GAME_ID.GONGA_MINE:
      endPoint = 'fast-games/mine-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed,
        mineCount: data?.numberOfGongaMines
      }
      break

    case DEFAULT_GAME_ID.COIN_FLIP:
      endPoint = 'fast-games/coin-flip-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    case DEFAULT_GAME_ID.SPACE_DICE:
      endPoint = 'fast-games/space-dice-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    case DEFAULT_GAME_ID.WHEEL:
      endPoint = 'fast-games/wheel-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed,
        riskLevel: data?.riskLevel,
        segments: data?.wheelSegments
      }
      break

    case DEFAULT_GAME_ID.TOWER:
      endPoint = 'fast-games/tower-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed,
        gameModeType: data?.gameModeType,
        difficultyType: data?.difficultyType
      }
      break

    default:
      break
  }
  return axiosInstanceService(METHOD_TYPES.post, endPoint, payLoadData, {
    server: microServices.SERVICE_URL_1
  })
}
